// 版（スマホ版／PC版）と文字の大きさ（#115）：ほかの import より先に読み込み、描く前に <html> に data-view・data-text を付ける
import "./lib/view.js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.jsx";
import { PRELOGIN_PRODUCT, applyBranding } from "./lib/product.js";
import { applyMode, applyTheme, productTheme } from "./lib/theme.js";
import { installInputStart } from "./lib/inputStart.js";
import { installTrail } from "./lib/trail.js";
import { registerReceived } from "./kits/received/index.jsx";
import { registerField } from "./products/field/index.jsx";
import { registerSales } from "./products/sales/index.jsx";
import "./styles.css";

// 製品（049）：ホスト名（開発は ?product=／VITE_PRODUCT）で <title>・favicon・manifest を決める。ログイン後は Shell が会社の製品で上書きする
applyBranding(PRELOGIN_PRODUCT);
// テーマ色（#191）：描く前に製品の既定（現場力＝藍、営業力＝濃い青）。ログインしたら App の ThemeHost が人の設定に
applyTheme(productTheme(PRELOGIN_PRODUCT));
// 明るさ（#191 の2回目）：描く前はライト（人の設定はログインしてから ThemeHost が当てる）
applyMode("light");

// 製品の画面の並び（部品を土台の差し込み口へ。../eigyouryoku/docs/09 §4.1）。出す／出さないは会社のモジュールで決まる
registerSales();
registerField();
// 両製品の部品（受け取った書類。門は core）
registerReceived();

// 打つ欄は、欄を離れたとき先頭から見える（S-00009）
installInputStart();

// 問い合わせの「？」に添える足あと（押したボタン・画面のエラー。#144、docs/53 §8.4）
installTrail();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
